import { number, object, ObjectSchema, setLocale, string } from 'yup'
import { es } from 'yup-locales'

import { yupSinTipoMonedaValidator } from '../../../base/validator/inputs'

setLocale(es)
export const monedaInputValidator: ObjectSchema<any> = object({
  sinMoneda: yupSinTipoMonedaValidator.required(),
  sigla: string().required(),
  descripcion: string().required(),
  tipoCambio: number().positive().required(),
  tipoCambioCompra: number().min(0).default(null).nullable(),
})
